var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadioBlanki = function SvgRadioBlanki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 1 0 0 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe2e5",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 1 0 0 18m0-1.4a7.6 7.6 0 1 1 0-15.2 7.6 7.6 0 1 1 0 15.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadioBlanki);
export default ForwardRef;